import { callApi } from "../api.service";
import { ManatalIntegrationStatus } from "../../models/manatalIntegration";

const apiServerUrl = import.meta.env.VITE_API_SERVER_URL;
const BASE = `${apiServerUrl}/api/integrations/manatal`;

export const getManatalStatus = (accessToken?: string) =>
  callApi<ManatalIntegrationStatus>(BASE, {
    method: "GET",
    headers: accessToken
      ? { Authorization: `Bearer ${accessToken}` }
      : undefined,
  });

export const validateManatalIntegration = (apiKey: string, accessToken?: string) =>
  callApi<ManatalIntegrationStatus>(`${BASE}/validate`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
    body: JSON.stringify({ api_key: apiKey }),
  });

export const disconnectManatalIntegration = (accessToken?: string) =>
  callApi<ManatalIntegrationStatus>(BASE, {
    method: "DELETE",
    headers: accessToken
      ? { Authorization: `Bearer ${accessToken}` }
      : undefined,
  });
